module.exports = __webpack_public_path__ + "img/icon4.ddb5269f.png";